import ServicePageLayout from '../../components/feature/ServicePageLayout';

export default function PleatedBlindsPage() {
  return (
    <ServicePageLayout
      blindType="Pleated Blinds"
      heroTitle="Pleated Blinds Northampton"
      heroSubtitle="Elegant Fabric Blinds Perfect for Skylights & Conservatories"
      introText="Pleated blinds feature soft, folded fabric that creates an elegant, contemporary look. They're incredibly versatile and particularly popular for conservatory roofs, skylights, and unusual shaped windows. Available in a wide range of fabrics including blackout and thermal options."
      heroImage="https://public.readdy.ai/ai/img_res/a6bd25164fd42047793893610df9bf3a.jpg"
      features={[
        { icon: 'ri-home-4-line', title: 'Perfect for Skylights', desc: 'Ideal solution for roof windows and conservatory panels' },
        { icon: 'ri-shape-line', title: 'Unusual Shapes', desc: 'Can be made to fit triangular, arched and angled windows' },
        { icon: 'ri-temp-cold-line', title: 'Thermal Insulation', desc: 'Honeycomb pleated options provide excellent insulation' },
        { icon: 'ri-contrast-drop-2-line', title: 'Light Filtering Options', desc: 'Choose from sheer, dimout or blackout fabrics' },
        { icon: 'ri-compasses-2-line', title: 'Compact Design', desc: 'Minimal stack height when fully opened' },
        { icon: 'ri-palette-line', title: 'Wide Fabric Range', desc: 'Huge choice of colours, patterns and textures' },
      ]}
      pricePerBlind="£119"
      wholeHousePrice="£899"
      benefits={[
        { icon: 'ri-check-line', text: 'Perfect for conservatories' },
        { icon: 'ri-check-line', text: 'Fits unusual shaped windows' },
        { icon: 'ri-check-line', text: 'Honeycomb insulation option' },
        { icon: 'ri-check-line', text: 'Blackout fabrics available' },
        { icon: 'ri-check-line', text: 'Professional installation' },
      ]}
      faqs={[
        {
          question: 'What\'s the difference between standard and honeycomb pleated blinds?',
          answer: 'Standard pleated blinds have a single layer of folded fabric, while honeycomb (or cellular) pleated blinds have a double-layered structure that creates air pockets. Honeycomb blinds provide significantly better insulation, making them ideal for conservatories and skylights.'
        },
        {
          question: 'Are pleated blinds good for conservatory roofs?',
          answer: 'Yes! Pleated blinds are one of the best choices for conservatory roofs. They can be fitted to angled panels, provide excellent light control, and honeycomb versions help regulate temperature by reducing heat gain in summer and heat loss in winter.'
        },
        {
          question: 'Can pleated blinds fit shaped windows?',
          answer: 'Absolutely. Pleated blinds are highly versatile and can be made to fit triangular, arched, angled, and other unusually shaped windows that standard blinds can\'t accommodate.'
        },
        {
          question: 'Do pleated blinds provide blackout?',
          answer: 'Yes, we offer pleated blinds in blackout fabrics that block out virtually all light. These are perfect for bedrooms, media rooms, or conservatories where you want complete light control.'
        },
        {
          question: 'How do pleated blinds operate?',
          answer: 'Pleated blinds typically operate with a cord or wand system. For skylight and roof installations, we often use a tensioned system where the blind is held taut against the window. Motorized options are also available for hard-to-reach windows.'
        },
        {
          question: 'Are pleated blinds easy to clean?',
          answer: 'Yes, pleated blinds are easy to maintain. Regular dusting with a soft brush or vacuum cleaner attachment keeps them looking fresh. For deeper cleaning, most fabrics can be gently wiped with a damp cloth.'
        },
      ]}
      additionalContent={
        <section className="py-10 sm:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                  The Ultimate Solution for Conservatories & Skylights in Northampton
                </h3>
                <p className="text-gray-700 mb-6">
                  Pleated blinds have become the preferred choice for conservatory owners across Northampton, and it's easy to see why. Their ability to fit angled roof panels, combined with excellent insulation properties (especially honeycomb versions), makes them perfect for keeping your conservatory comfortable all year round. Whether you need to control glare from skylights, reduce heat in summer, or add a touch of elegance to unusual shaped windows, our pleated blinds offer the perfect solution.
                </p>
              </div>
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=pleated%20blinds%20installed%20on%20conservatory%20roof%20skylight%20panels%20soft%20folded%20fabric%20elegant%20light%20filtering%20bright%20airy%20space%20no%20people%20professional%20photography&width=800&height=600&seq=pleated-add-001&orientation=landscape"
                  alt="Pleated Blinds in Conservatory"
                  className="w-full h-64 object-cover"
                />
              </div>
            </div>
          </div>
        </section>
      }
    />
  );
}